<template>
  <div>
    <v-dialog
      v-model="show"
      max-width="960px"
      transition="dialog-transition"
      @click:outside="closeUpdateUserModal(false, '')"
    >
      <v-card rounded="lg">
        <!-- Header -->
        <div class="modal-header px-8 pt-6 pb-0">
          <div class="d-flex align-center justify-space-between mb-4">
            <span class="text-h6 font-weight-bold">Mi cuenta</span>
            <v-btn icon small @click="closeUpdateUserModal(false, '')">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>

          <!-- Tabs -->
          <v-tabs v-model="activeTab" color="primary" show-arrows>
            <v-tab href="#tab-profile">
              <v-icon left small>mdi-account-outline</v-icon>
              Mi cuenta
            </v-tab>
            <v-tab href="#tab-settings">
              <v-icon left small>mdi-cog-outline</v-icon>
              Configuración
            </v-tab>
            <v-tab href="#tab-templates">
              <v-icon left small>mdi-text-box-multiple-outline</v-icon>
              Plantillas de mensaje
            </v-tab>
          </v-tabs>
        </div>

        <v-divider />

        <v-tabs-items v-model="activeTab">
          <!-- Tab: Mi cuenta -->
          <v-tab-item value="tab-profile">
            <v-card-text class="px-8 py-6">
              <v-row>
                <v-col
                  v-if="userToUpdate"
                  cols="12"
                  sm="3"
                  class="d-flex flex-column align-center pa-4 grey lighten-4 rounded-lg"
                >
                  <v-avatar color="indigo" size="96" class="mb-3">
                    <img
                      :src="getProfileImg($store.state.userData.media)"
                      :alt="userToUpdate.name"
                    />
                  </v-avatar>
                  <edit-avatar class="ma-0" />
                  <UploadImageCloudinary class="mt-1" />
                  <v-btn
                    text
                    small
                    color="warning"
                    class="mt-3 text-capitalize"
                    @click="restorePassword(userToUpdate)"
                  >
                    <v-icon left small>mdi-pencil-lock</v-icon>
                    Cambiar contraseña
                  </v-btn>
                  <v-divider class="my-4 align-self-stretch" />
                  <div
                    class="text-caption grey--text text--darken-1 align-self-start mb-1"
                  >
                    Registro
                  </div>
                  <div class="text-body-2 align-self-start mb-3">
                    {{ getSpanishDate(userToUpdate.created_at) }}
                  </div>
                  <div
                    class="text-caption grey--text text--darken-1 align-self-start mb-1"
                  >
                    Última actualización
                  </div>
                  <div class="text-body-2 align-self-start">
                    {{ getSpanishDate(userToUpdate.updated_at) }}
                  </div>
                </v-col>
                <v-col cols="12" sm="9">
                  <v-form
                    ref="updateContactForm"
                    v-model="updateContactFormValid"
                  >
                    <v-row justify="space-between" align="center">
                      <v-col cols="12" sm="">
                        <div class="mb-3">
                          <h3>
                            Nombre
                          </h3>
                        </div>
                        <v-text-field
                          v-model="name"
                          :rules="nameRules"
                          :disabled="isLoadingUpdateUser"
                          outlined
                          placeholder="Nombre"
                          required
                        />
                      </v-col>
                      <v-col cols="12" sm="6">
                        <div class="mb-3">
                          <h3>
                            Usuario
                          </h3>
                        </div>
                        <v-text-field
                          v-model="userName"
                          disabled
                          filled
                          placeholder="Usuario"
                          required
                        />
                      </v-col>
                    </v-row>
                    <v-row justify="space-between" align="center">
                      <v-col cols="12" sm="6">
                        <div class="mb-3">
                          <h3>
                            Correo
                          </h3>
                        </div>
                        <v-text-field
                          v-model="email"
                          :rules="emailRules"
                          filled
                          placeholder="Correo"
                          required
                        />
                      </v-col>
                      <v-col cols="12" sm="6">
                        <div class="mb-3">
                          <h3>
                            Teléfono
                          </h3>
                        </div>
                        <v-text-field
                          v-model="phone"
                          :disabled="isLoadingUpdateUser"
                          outlined
                          placeholder="Teléfono"
                          required
                        />
                      </v-col>
                    </v-row>
                  </v-form>
                </v-col>
              </v-row>
              <small class="red--text">{{ messageError }}</small>
            </v-card-text>
            <v-divider class="mt-4" />
            <v-card-actions class="px-8 py-4">
              <v-spacer />
              <v-btn
                text
                :disabled="isLoadingUpdateUser"
                @click="closeUpdateUserModal(false, '')"
              >
                Cancelar
              </v-btn>
              <v-btn
                color="primary"
                depressed
                :disabled="isLoadingUpdateUser"
                :loading="isLoadingUpdateUser"
                @click="validateUpdateUserForm()"
              >
                Actualizar
              </v-btn>
            </v-card-actions>
          </v-tab-item>

          <!-- Tab: Configuración -->
          <v-tab-item value="tab-settings">
            <v-card-text class="px-8 py-6">
              <v-row>
                <v-col cols="12" sm="6" offset-sm="3">
                  <notification-settings
                    :user-to-update="userToUpdate"
                    :visible="activeTab === 'tab-settings'"
                  />
                </v-col>
              </v-row>
            </v-card-text>
          </v-tab-item>

          <!-- Tab: Plantillas de mensaje -->
          <v-tab-item value="tab-templates">
            <v-card-text class="px-8 py-6">
              <message-templates :visible="activeTab === 'tab-templates'" />
            </v-card-text>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </v-dialog>
    <restore-password-user-modal
      :visible="showRestoreUserModal"
      :user-to-restore="userToUpdate"
      @close="onCloseRestoreUserModal"
    />
  </div>
</template>
<script>
import moment from "moment";
import { mapState, mapActions, mapMutations } from "vuex";
export default {
  components: {
    RestorePasswordUserModal: () =>
      import("@/components/user/UserRestorePassword.vue"),
    UploadImageCloudinary: () =>
      import("@/components/upload/UploadImageCloudinary.vue"),
    EditAvatar: () => import("@/components/user/EditAvatarComponent.vue"),
    NotificationSettings: () =>
      import("@/components/user/NotificationSettings.vue"),
    MessageTemplates: () => import("@/components/user/MessageTemplates.vue")
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    userToUpdate: {
      type: Object,
      default: () => null
    },
    realEstate: {
      type: Array,
      default: () => []
    },
    allLocation: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      activeTab: "tab-profile",
      updateContactFormValid: true,
      isLoadingUpdateUser: false,
      updatedData: null,
      messageError: "",
      statusUpdate: "",
      role: "",
      name: "",
      nameRules: [v => !!v || "El nombre es requerido"],
      userName: "",
      userNameRules: [v => !!v || "El usuario es requerido"],
      phone: "",
      phoneRules: [
        v => !!v || "El teléfono es requerido",
        // v => v.length >= 10 || "The phone number is incorrect",
        // v => v.length <= 10 || "The phone number is incorrect",
        v =>
          Number.isInteger(Number(v)) || "El teléfono no puede contener letras"
      ],
      email: "",
      emailRules: [
        v => !!v || "E-mail es requerido",
        v => /.+@.+/.test(v) || "E-mail no valido"
      ],
      showRestoreUserModal: false,
      userToRestore: null,
      dataEdited: null,
      showTooltip: false
    };
  },
  computed: {
    ...mapState({
      contactListSt: state => state.contacts.contactList
    }),
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close", this.updatedData, this.dataEdited);
        }
      }
    }
  },
  watch: {
    userToUpdate(newValue) {
      if (newValue) {
        this.name = this.$store.state.userData.name
          ? this.$store.state.userData.name
          : "";
        this.email = newValue.email ? newValue.email : "";
        this.phone = newValue.phone ? newValue.phone : "";
        this.role = newValue.role ? newValue.role : "";
      } else {
        this.name = "";
        this.email = "";
        this.phone = "";
        this.role = "";
        this.selectedRealEstate = [];
      }
    },
    visible(val) {
      if (!val) {
        this.activeTab = "tab-profile";
      }
    }
  },
  methods: {
    ...mapActions({
      updateContactByIdStore: "contacts/updateContactById"
    }),
    ...mapMutations({
      setContactStore: "contacts/setContact"
    }),
    closeUpdateUserModal(val, dataEdited) {
      this.messageError = "";
      this.dataEdited = dataEdited;
      this.show = val;
      this.$refs.updateContactForm.resetValidation();
    },
    onCloseRestoreUserModal(canceled) {
      if (canceled) {
        this.userToRestore = null;
        this.showRestoreUserModal = false;
      } else {
        this.userToRestore = null;
        this.showRestoreUserModal = false;
        this.closeUpdateUserModal(false, "password");
      }
    },
    restorePassword(item) {
      this.userToRestore = item;
      this.showRestoreUserModal = true;
    },
    validateUpdateUserForm() {
      if (this.$refs.updateContactForm.validate()) {
        this.updateContact();
      } else {
        this.messageError = "Por favor, verifica los errores.";
      }
    },
    updateContact() {
      this.isLoadingUpdateUser = true;
      try {
        const info = {
          role: this.role,
          data: {
            _id: this.userToUpdate._id,
            user_id: this.userToUpdate.user_id,
            table: this.role,
            role: this.role,
            name: this.name,
            email: this.email,
            phone: this.phone
          }
        };
        this.updateContactByIdStore(info).then(res => {
          if (res && res.user != undefined) {
            this.statusUpdate = "Success";
            this.isLoadingUpdateUser = false;
            this.updatedData = res.user;
            this.closeUpdateUserModal(false, "profile");
          } else {
            this.updatedData = null;
            this.statusUpdate = "Error";
            this.isLoadingUpdateUser = false;
          }
        });
      } catch (error) {
        this.updatedData = null;
        this.statusUpdate = "Error";
        this.isLoadingUpdateUser = false;
      }
    },
    getProfileImg(m) {
      let media = m !== undefined && m !== null && m !== "" ? m : {};
      if (media.hasOwnProperty("featured_image")) {
        if (media.featured_image.hasOwnProperty("src")) {
          if (
            media.featured_image.src !== null &&
            media.featured_image.src !== ""
          ) {
            return media.featured_image.src;
          } else {
            return "https://upload.wikimedia.org/wikipedia/commons/thumb/5/57/OOjs_UI_icon_userAvatar-progressive.svg/600px-OOjs_UI_icon_userAvatar-progressive.svg.png";
          }
        } else if (media.featured_image.hasOwnProperty("src_avatar")) {
          if (
            media.featured_image.src_avatar !== null &&
            media.featured_image.src_avatar !== ""
          ) {
            return media.featured_image.src_avatar;
          } else {
            return "https://upload.wikimedia.org/wikipedia/commons/thumb/5/57/OOjs_UI_icon_userAvatar-progressive.svg/600px-OOjs_UI_icon_userAvatar-progressive.svg.png";
          }
        } else {
          return "https://upload.wikimedia.org/wikipedia/commons/thumb/5/57/OOjs_UI_icon_userAvatar-progressive.svg/600px-OOjs_UI_icon_userAvatar-progressive.svg.png";
        }
      } else {
        return "https://upload.wikimedia.org/wikipedia/commons/thumb/5/57/OOjs_UI_icon_userAvatar-progressive.svg/600px-OOjs_UI_icon_userAvatar-progressive.svg.png";
      }
    },
    getSpanishDate(date) {
      if (date === undefined || date === null || date === "") {
        return moment(new Date())
          .locale("es")
          .format("LL");
      } else {
        return moment(new Date(date))
          .locale("es")
          .format("LL");
      }
    }
  }
};
</script>

<style scoped>
.modal-header {
  background: #fff;
}
</style>
